const waitForElement = (_selector, callback, bypassDisconnect = false) => {
  const elObserver = new MutationObserver((_mutations, observer) => {
    const element = document.querySelector(_selector)
    if (element) {
      callback(element)
      if (!bypassDisconnect) {
        observer.disconnect()
      }
    }
  })

  elObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
}

const observeIntersection = (
  selector,
  options,
  callback,
  bypassDisconnect = false
) => {
  const elements = document.querySelectorAll(selector)
  const elObserver = new IntersectionObserver((entries, observer) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        callback(entry.target, observer)
        if (!bypassDisconnect) {
          observer.unobserve(entry.target)
        }
      }
    }
  }, options)

  for (const element of elements) {
    elObserver.observe(element)
  }
}

export { waitForElement, observeIntersection }
